import { Form, i18n, Row, Cell, RichEditorReference, ImageUploader, utils } from '@common';
import { I18N } from "../../../Common/tools";
import { adminService, accountService } from "@api";
export default class RichEditorReferenceImage extends R.Component {
    componentCreate() {
        this.state = {
            items: []
        };
        this.referenceImageEditorRef = React.createRef();
    }

    updateValue(val) {
        this.referenceImageEditorRef.updateValue(val);
    }

    insertReference(value) {
        this.referenceImageEditorRef.insertReference(value);
    }

    render() {
        const { references, getEditorValue } = this.props;
        return (
            <RichEditorReference
                id='richeditor-body'
                ref={el => this.referenceImageEditorRef = el}
                referenceList={references} onChange={getEditorValue}
                attrs={{ 'aria-labelledby': Form.formlabel }}
                supportInsertImageLibrary
            />
        );
    }
}

RichEditorReference.CustomInsertImageLibraryDialog = class extends R.Component {
    componentCreate() {
        this.state = {
            status: { show: false },
            imageWidth: "280",
            imageHeight: "60",
        };
        this.bind('handleChange', 'onOKBtnClick', 'onCancelBtnClick', 'onImgPhotoChange', 'onImgPhotoError');
    }

    componentInit() {
        this.setState({ status: { show: true } });
    }

    handleChange(name, args) {
        this.setState({ [name]: args });
    }

    onCancelBtnClick() {
        this.setState({ status: { show: false } });
    }

    async onOKBtnClick() {
        if (this.state.errorMsg) {
            return false;
        }
        $$.loading(true);
        const { imageWidth, imageHeight, image, name } = this.state;

        const imgHtml = this.props.editor.document.createElement('img');
        accountService.getCurrentUser().then(res => {
            const UPN = res?.detail?.ext?.UserPrincipalName || '';
            const param = { photoName: name, modifiedBy: UPN, photo: image };
            adminService.photoSave(param).then(res => {
                const id = res?.message || '';
                const url = `https://cis-uat.polite.edu.sg/api/manage/GetTemplatesPhotoByCache?id=${id}`;
                imgHtml.setAttribute('src', url);
            });
        }).catch(e => {
            utils.redirectTo(`${utils.getOriginUrl()}/error/urlexpired`);
        });

        imgHtml.setAttribute('alt', name);
        // imgHtml.setAttribute('data-id', '1112222');
        if (imageWidth) imgHtml.setAttribute('width', imageWidth + 'px');
        if (imageHeight) imgHtml.setAttribute('height', imageHeight + 'px');
        if (imageWidth && imageHeight) {
            imgHtml.setStyle('aspect-ratio', `${imageWidth}/${imageHeight}`);
        }
        else if (imageHeight) {
            const { width, height } = await this.loadImage(image);
            const w = imageHeight * (width / height);
            imgHtml.setStyle('width', w + 'px');
            imgHtml.setStyle('aspect-ratio', `${w}/${imageHeight}`);
        }
        $$.loading(false);
        this.props.editor.insertElement(imgHtml);
        this.setState({ status: { show: false } });
    }
    loadImage(src) {
        return new Promise(resolve => {
            const img = new Image();
            img.src = src;
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
        });
    }
    onImgPhotoChange(image) {
        const url = image.url?.split(',')[1] || '';
        this.setState({
            image: url,
            name: image.name,
            errorMsg: null
        });
    }

    onImgPhotoError(message) {
        this.setState({
            errorMsg: message
        });
    }

    render() {
        const { status, imageWidth, imageHeight, errorMsg } = this.state;
        const buttons = [{
            text: i18n.get('Common_Cancel_Entry'),
            name: 'cancel',
            onClick: this.onCancelBtnClick,
        }, {
            text: i18n.get('Common_OK_Entry'),
            name: 'ok',
            onClick: this.onOKBtnClick,
            theme: true,
            disabled: !this.state.image || errorMsg
        }];

        return (
            <R.Dialog
                title={i18n.get('CIS_Admin_EmailTemplate_RichEditor_Title__Entry')}
                width={464}
                status={status}
                buttons={buttons}
                destroy={false}
                onClose={this.props.onClose}
            >
                <Form id="form-insert-image">
                    <Row>
                        <Cell>
                            <ImageUploader
                                fileTypes={["png", "jpg", "jpeg"]}
                                maxSize={`200${I18N.kb}`}
                                attrs={{ 'aria-labelledby': Form.formlabel }}
                                type="base64"
                                height={'400px'}
                                ratio="280*60"
                                base64={''}
                                position="bottom"
                                onChange={this.onImgPhotoChange.bind(this)}
                                onError={this.onImgPhotoError.bind(this)} />
                            <R.ValidationFaker valid={!errorMsg} message={i18n.get('CIS_Admin_EmailTemplate_RichEditor_Error__Entry')} />
                        </Cell>
                    </Row>
                    <Row>
                        <Cell label={i18n.get('CIS_Admin_EmailTemplate_ImageWidth__Entry')}>
                            <R.Input type="number" min={1} value={imageWidth} onChange={this.handleChange.bind(this, 'imageWidth')} />
                        </Cell>
                        <Cell label={i18n.get('CIS_Admin_EmailTemplate_ImageHeight__Entry')}>
                            <R.Input type="number" min={1} value={imageHeight} onChange={this.handleChange.bind(this, 'imageHeight')} />
                        </Cell>
                    </Row>
                </Form>
            </R.Dialog>
        );
    }
};
